import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "col-sm-12" }
const _hoisted_2 = { class: "card card-body mb-0" }
const _hoisted_3 = {
  key: 0,
  class: "row mb-2"
}
const _hoisted_4 = { class: "form-group col-sm-12" }
const _hoisted_5 = { class: "navbar-nav overflow-auto flex-row gap-4" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "form-group me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_9 = { class: "col p-0" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  key: 0,
  class: "form-group col-md-3 col-lg-3 col-xl-2 me-2 d-flex"
}
const _hoisted_13 = { class: "col p-0 d-flex align-items-center" }
const _hoisted_14 = { class: "form-check small mb-0" }
const _hoisted_15 = {
  class: "form-check-label",
  for: "isMainTeamLead"
}
const _hoisted_16 = { class: "form-group col" }
const _hoisted_17 = { class: "col-auto p-0 text-end" }
const _hoisted_18 = { class: "col-sm-12" }
const _hoisted_19 = { class: "card card-body" }
const _hoisted_20 = { class: "overflow-auto" }
const _hoisted_21 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_22 = { class: "text-capitalize-first" }
const _hoisted_23 = { class: "text-capitalize-first" }
const _hoisted_24 = {
  key: 0,
  class: "text-capitalize-first"
}
const _hoisted_25 = { class: "text-end" }
const _hoisted_26 = ["title"]
const _hoisted_27 = ["title"]
const _hoisted_28 = ["title"]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-sm-12 d-flex align-items-center justify-content-between" }
const _hoisted_32 = { class: "d-flex align-items-center flex-column" }
const _hoisted_33 = { class: "d-flex align-items-center" }
const _hoisted_34 = {
  key: 0,
  class: "me-2 text-secondary"
}
const _hoisted_35 = ["title"]
const _hoisted_36 = {
  key: 1,
  class: "btn-group me-2"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "dropdown-menu" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "text-end" }
const _hoisted_43 = {
  key: 0,
  class: "text-danger",
  style: {"font-size":"70%"}
}
const _hoisted_44 = { class: "text-end" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 3,
  class: "btn-group"
}
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "dropdown-menu" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "row mb-3 mt-3" }
const _hoisted_55 = { class: "col-sm-12" }
const _hoisted_56 = { class: "p-0 m-0" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { class: "col-sm-12" }
const _hoisted_59 = { class: "me-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserForm = _resolveComponent("UserForm")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_UserNameLabel = _resolveComponent("UserNameLabel")!
  const _component_AccountWidget = _resolveComponent("AccountWidget")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_InviteLinkConfirmModal = _resolveComponent("InviteLinkConfirmModal")!
  const _component_AccountOperationsModal = _resolveComponent("AccountOperationsModal")!
  const _component_TeamLeadRewardSettingsForm = _resolveComponent("TeamLeadRewardSettingsForm")!
  const _component_ReferralMerchantFeesTable = _resolveComponent("ReferralMerchantFeesTable")!
  const _component_WithdrawalForm = _resolveComponent("WithdrawalForm")!
  const _component_AutoWithdrawalSettingsModal = _resolveComponent("AutoWithdrawalSettingsModal")!
  const _component_WithdrawalWhitelistModal = _resolveComponent("WithdrawalWhitelistModal")!
  const _component_ChangePasswordModal = _resolveComponent("ChangePasswordModal")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.role === _ctx.UserRole.ADMIN)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("ul", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.StatusTabs, (value, tab) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: tab,
                        class: "nav-item nav-item-spaced d-lg-block text-nowrap"
                      }, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _withModifiers(($event: any) => (_ctx.selectStatusTab(tab)), ["prevent"]),
                          class: _normalizeClass(["nav-link tab", {'active': _ctx.activeStatusTab === tab}])
                        }, _toDisplayString(_ctx.helper.trans(`users.status.${tab}`)), 11, _hoisted_6)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm",
                    onKeydown: _cache[0] || (_cache[0] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
                    placeholder: _ctx.helper.trans('labels.name'),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestDTO.query) = $event))
                  }, null, 40, _hoisted_11), [
                    [_vModelText, _ctx.requestDTO.query]
                  ])
                ])
              ])
            ]),
            (_ctx.role === _ctx.UserRole.TRADER_TEAM_LEAD)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestDTO.isMainTeamLead) = $event)),
                        "true-value": "y",
                        type: "checkbox",
                        value: "",
                        id: "isMainTeamLead"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.requestDTO.isMainTeamLead]
                      ]),
                      _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.helper.trans('labels.is_main_teamLead')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                  class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                  class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("table", _hoisted_21, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[25] || (_cache[25] = _createElementVNode("td", null, null, -1)),
                  _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                  _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.helper.trans('labels.name')), 1),
                  _cache[26] || (_cache[26] = _createElementVNode("th", null, "2FA", -1)),
                  (_ctx.role === _ctx.UserRole.TRADER_TEAM_LEAD || _ctx.role === _ctx.UserRole.REFERRAL || _ctx.role === _ctx.UserRole.ADMIN)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_24, _toDisplayString(_ctx.helper.trans('labels.balances')), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("th", _hoisted_25, [
                    (_ctx.role !== _ctx.UserRole.ADMIN || (_ctx.store.getters.hasPermission(_ctx.UserPermission.CREATE_ADMINS)))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showEditModal({}))),
                          class: "btn btn-outline-primary btn-sm text-capitalize"
                        }, _toDisplayString(_ctx.helper.trans('button.create')), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_b_modal, {
                      "dialog-class": "modal-lg",
                      title: _ctx.createModalTitle,
                      modelValue: _ctx.createModal,
                      "body-class": "pt-0",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.createModal = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UserForm, {
                          ref: "createForm",
                          role: _ctx.role
                        }, null, 8, ["role"])
                      ]),
                      footer: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.createModal = false)),
                          class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                        }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
                        _createVNode(_component_LoaderWrapper, {
                          ref: "loaderCreateFrom",
                          zoom: 0.5
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.save())),
                              class: "btn btn-outline-primary btn-sm text-capitalize-first"
                            }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
                          ]),
                          _: 1
                        }, 512)
                      ]),
                      _: 1
                    }, 8, ["title", "modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.items, (user) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: user.id,
                    class: ""
                  }, [
                    _createElementVNode("td", null, [
                      (user.isBlocked)
                        ? _withDirectives((_openBlock(), _createElementBlock("i", {
                            key: 0,
                            title: _ctx.helper.trans('labels.user_blocked'),
                            class: "fa fa-ban text-danger"
                          }, null, 8, _hoisted_26)), [
                            [
                              _directive_b_tooltip,
                              void 0,
                              void 0,
                              { hover: true }
                            ]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(user.id), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_UserNameLabel, { user: user }, null, 8, ["user"])
                    ]),
                    _createElementVNode("td", null, [
                      (user.is2faEnabled)
                        ? _withDirectives((_openBlock(), _createElementBlock("i", {
                            key: 0,
                            title: _ctx.helper.trans('labels.enabled'),
                            class: "fa fa-check text-success"
                          }, null, 8, _hoisted_27)), [
                            [
                              _directive_b_tooltip,
                              void 0,
                              void 0,
                              { hover: true }
                            ]
                          ])
                        : _withDirectives((_openBlock(), _createElementBlock("i", {
                            key: 1,
                            title: _ctx.helper.trans('labels.disabled'),
                            class: "fa fa-ban text-danger"
                          }, null, 8, _hoisted_28)), [
                            [
                              _directive_b_tooltip,
                              void 0,
                              void 0,
                              { hover: true }
                            ]
                          ])
                    ]),
                    (_ctx.role === _ctx.UserRole.TRADER_TEAM_LEAD || _ctx.role === _ctx.UserRole.REFERRAL || _ctx.role === _ctx.UserRole.ADMIN)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_29, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user._accounts, (userAccount) => {
                            return (_openBlock(), _createElementBlock("div", null, [
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("div", _hoisted_31, [
                                  _createVNode(_component_AccountWidget, {
                                    "hide-insurance": "",
                                    account: userAccount
                                  }, null, 8, ["account"]),
                                  _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("div", _hoisted_33, [
                                      (_ctx.isAdmin || _ctx.isOperator)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                            _withDirectives((_openBlock(), _createElementBlock("small", {
                                              title: userAccount.id
                                            }, [
                                              _createTextVNode(_toDisplayString(userAccount.id.substring(0, 8)), 1)
                                            ], 8, _hoisted_35)), [
                                              [
                                                _directive_b_tooltip,
                                                void 0,
                                                void 0,
                                                { hover: true }
                                              ]
                                            ]),
                                            _cache[27] || (_cache[27] = _createTextVNode()),
                                            _createVNode(_component_copy_button, {
                                              value: userAccount.id
                                            }, null, 8, ["value"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (user.id === _ctx.store.getters.getUser.id)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                            _createElementVNode("button", {
                                              type: "button",
                                              onClick: _withModifiers(($event: any) => (_ctx.withdrawAccount = userAccount), ["prevent"]),
                                              class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                                            }, [
                                              _cache[28] || (_cache[28] = _createElementVNode("i", { class: "fa-solid fa-upload" }, null, -1)),
                                              _createTextVNode(" " + _toDisplayString(_ctx.helper.trans("button.withdraw")), 1)
                                            ], 8, _hoisted_37),
                                            _cache[29] || (_cache[29] = _createElementVNode("button", {
                                              type: "button",
                                              class: "btn btn-sm btn-outline-dark dropdown-toggle dropdown-toggle-split",
                                              "data-bs-toggle": "dropdown",
                                              "aria-expanded": "false"
                                            }, [
                                              _createElementVNode("span", { class: "visually-hidden" })
                                            ], -1)),
                                            _createElementVNode("ul", _hoisted_38, [
                                              _createElementVNode("li", null, [
                                                _createElementVNode("a", {
                                                  class: "dropdown-item text-capitalize-first",
                                                  href: "#",
                                                  onClick: _withModifiers(($event: any) => {_ctx.withdrawalWhitelistModal?.show(userAccount);}, ["prevent"])
                                                }, _toDisplayString(_ctx.helper.trans('labels.edit_whitelist')), 9, _hoisted_39)
                                              ]),
                                              _createElementVNode("li", null, [
                                                _createElementVNode("a", {
                                                  class: "dropdown-item text-capitalize-first",
                                                  href: "#",
                                                  onClick: _withModifiers(($event: any) => (_ctx.autoWithdrawalSettingsModal?.show(userAccount)), ["prevent"])
                                                }, _toDisplayString(_ctx.helper.trans('labels.edit_auto_withdrawal')), 9, _hoisted_40)
                                              ])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.isAdmin || _ctx.isOperator)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 2,
                                            onClick: ($event: any) => (_ctx.$refs.accountOperationsModal.showModal(userAccount)),
                                            class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize-first"
                                          }, _toDisplayString(_ctx.helper.trans("menu.items.accountOperations")), 9, _hoisted_41))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_42, [
                                      (userAccount.isAutoWithdrawalEnabled &&  userAccount.withdrawalWhitelistsEnabled)
                                        ? (_openBlock(), _createElementBlock("small", _hoisted_43, _toDisplayString(_ctx.helper.trans('labels.auto_withdrawal_enabled', {
                            address: userAccount.autoWithdrawalAddress,
                            sum: userAccount.autoWithdrawalMinSum
                              ? _ctx.numberFormatter.formatMoney(userAccount.autoWithdrawalMinSum, 0)
                              : ''
                          })), 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          }), 256))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", _hoisted_44, [
                      (_ctx.isAdmin && _ctx.store.getters.hasPermission(_ctx.UserPermission.VIEW_USER_SESSION_HISTORY))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            onClick: _withModifiers(($event: any) => (_ctx.downloadSessionHistory(user.id)), ["prevent"]),
                            class: "btn btn-sm btn-outline-secondary text-nowrap text-capitalize me-2"
                          }, [
                            _cache[30] || (_cache[30] = _createElementVNode("i", { class: "fa fa-file-download" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.download_session_history')), 1)
                          ], 8, _hoisted_45))
                        : _createCommentVNode("", true),
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            onClick: ($event: any) => (_ctx.showEditModal(user)),
                            class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                          }, [
                            _cache[31] || (_cache[31] = _createElementVNode("i", { class: "fa fa-pencil" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.edit')), 1)
                          ], 8, _hoisted_46))
                        : _createCommentVNode("", true),
                      (_ctx.isOperator && _ctx.store.getters.hasPermission(_ctx.passwordPermission))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            onClick: _withModifiers(($event: any) => (_ctx.showChangePasswordModal(user)), ["prevent"]),
                            class: "btn btn-sm btn-outline-secondary text-nowrap text-capitalize"
                          }, [
                            _cache[32] || (_cache[32] = _createElementVNode("i", { class: "fa fa-key" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.change_password')), 1)
                          ], 8, _hoisted_47))
                        : _createCommentVNode("", true),
                      (user.role === _ctx.UserRole.TRADER_TEAM_LEAD)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.routingTeamLead = user),
                              class: "ms-2 btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                            }, [
                              _cache[33] || (_cache[33] = _createElementVNode("i", { class: "fa fa-percent" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.percent_rates')), 1)
                            ], 8, _hoisted_49),
                            _cache[36] || (_cache[36] = _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-outline-dark dropdown-toggle dropdown-toggle-split",
                              "data-bs-toggle": "dropdown",
                              "aria-expanded": "false",
                              "data-bs-reference": "parent"
                            }, [
                              _createElementVNode("span", { class: "visually-hidden" })
                            ], -1)),
                            _createElementVNode("ul", _hoisted_50, [
                              _createElementVNode("li", null, [
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  href: "#",
                                  onClick: _withModifiers(($event: any) => (_ctx.downloadTradersRate(user.id)), ["prevent"])
                                }, [
                                  _cache[34] || (_cache[34] = _createElementVNode("i", { class: "fa fa-file-export" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.download_traders_percent_rates')), 1)
                                ], 8, _hoisted_51)
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  href: "#",
                                  onClick: _withModifiers(($event: any) => (_ctx.ratesImportModal = user), ["prevent"])
                                }, [
                                  _cache[35] || (_cache[35] = _createElementVNode("i", { class: "fa fa-file-import" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.import_traders_percent_rates')), 1)
                                ], 8, _hoisted_52)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.role === _ctx.UserRole.REFERRAL && _ctx.store.getters.getAppData?.REFERRAL_MERCHANT_FEES_ENABLED)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 4,
                            type: "button",
                            onClick: ($event: any) => (_ctx.referralFeesUser = user),
                            class: "ms-2 btn btn-sm btn-outline-dark text-nowrap text-capitalize-first"
                          }, [
                            _cache[37] || (_cache[37] = _createElementVNode("i", { class: "fa fa-percent" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.referral_fees')), 1)
                          ], 8, _hoisted_53))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.response.totalCount > _ctx.response.items.length)
              ? (_openBlock(), _createBlock(_component_b_pagination, {
                  key: 0,
                  modelValue: _ctx.page,
                  "onUpdate:modelValue": [
                    _cache[9] || (_cache[9] = ($event: any) => ((_ctx.page) = $event)),
                    _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadList()))
                  ],
                  "total-rows": _ctx.response.totalCount,
                  "per-page": _ctx.response.limit,
                  limit: 20,
                  "prev-text": "Back",
                  "next-text": "Next",
                  align: "start",
                  "first-number": "",
                  "hide-goto-end-buttons": "",
                  "hide-ellipsis": ""
                }, null, 8, ["modelValue", "total-rows", "per-page"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode(_component_InviteLinkConfirmModal, { ref: "inviteLinkConfirmModal" }, null, 512),
      _createVNode(_component_AccountOperationsModal, { ref: "accountOperationsModal" }, null, 512),
      _createVNode(_component_b_modal, {
        "dialog-class": "modal-lg",
        title: `${_ctx.routingTeamLead?.name}`,
        modelValue: _ctx.routingTeamLead !== null,
        "body-class": "pt-0",
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ($event === false && (_ctx.routingTeamLead = null)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TeamLeadRewardSettingsForm, {
            ref: "routingRuleForm",
            "team-lead": _ctx.routingTeamLead
          }, null, 8, ["team-lead"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.routingTeamLead = null)),
            class: "btn btn-outline-secondary btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
          _createVNode(_component_LoaderWrapper, {
            ref: "loaderRoutingRule",
            zoom: 0.5
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.saveRouting())),
                class: "btn btn-outline-primary btn-sm text-capitalize-first"
              }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_b_modal, {
        "dialog-class": "modal-lg",
        title: `${_ctx.referralFeesUser?.name}`,
        modelValue: _ctx.referralFeesUser !== null,
        "body-class": "pt-0",
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ($event === false && (_ctx.referralFeesUser = null)))
      }, {
        default: _withCtx(() => [
          (_ctx.referralFeesUser)
            ? (_openBlock(), _createBlock(_component_ReferralMerchantFeesTable, {
                key: 0,
                "referral-id": _ctx.referralFeesUser.id
              }, null, 8, ["referral-id"]))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.referralFeesUser = null)),
            class: "btn btn-outline-secondary btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1)
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_b_modal, {
        title: _ctx.helper.trans('labels.import_traders_percent_rates'),
        modelValue: _ctx.ratesImportModal !== null,
        "header-class": "text-capitalize",
        "body-class": "pt-0",
        "footer-class": "d-flex justify-content-between",
        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ($event === false && (_ctx.ratesImportModal = null)))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _mergeProps({ style: {"cursor":"pointer","border":"1px dashed"} }, _ctx.dropzone.getRootProps(), { class: "payout-dropzone rounded border-secondary p-3 pt-4 pb-4 d-flex justify-content-center align-items-center" }), [
                _createElementVNode("input", _normalizeProps(_guardReactiveProps(_ctx.dropzone.getInputProps())), null, 16),
                _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.helper.trans('labels.payout_upload_files')), 1)
              ], 16)
            ])
          ]),
          (_ctx.importFile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _cache[39] || (_cache[39] = _createElementVNode("i", { class: "fa fa-paperclip" }, null, -1)),
                  _cache[40] || (_cache[40] = _createTextVNode()),
                  _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.importFile.name), 1),
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.importFile = null), ["prevent"]))
                  }, _cache[38] || (_cache[38] = [
                    _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                  ]))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.ratesImportModal = null)),
            class: "btn btn-outline-dark btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans("button.cancel")), 1),
          _createVNode(_component_LoaderWrapper, {
            ref: "loaderRatesImportModal",
            zoom: 0.5
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.importTraderRates(_ctx.ratesImportModal?.id))),
                class: "btn btn-outline-primary btn-sm text-capitalize-first"
              }, _toDisplayString(_ctx.helper.trans("labels.import")), 1)
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_b_modal, {
        title: _ctx.helper.trans('labels.withdrawal'),
        modelValue: _ctx.withdrawAccount !== null,
        "header-class": "text-capitalize",
        "body-class": "pt-0",
        "footer-class": "d-flex justify-content-between",
        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ($event === false && (_ctx.withdrawAccount = null)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_WithdrawalForm, {
            ref: "withdrawalForm",
            account: _ctx.withdrawAccount
          }, null, 8, ["account"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.withdrawAccount = null)),
            class: "btn btn-outline-dark btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans("button.cancel")), 1),
          _createVNode(_component_LoaderWrapper, {
            ref: "loaderWithdrawalForm",
            zoom: 0.5
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.createWithdraw())),
                class: "btn btn-outline-primary btn-sm text-capitalize-first"
              }, _toDisplayString(_ctx.helper.trans("button.withdraw")), 1)
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_AutoWithdrawalSettingsModal, {
        "onAccount:updated": _cache[23] || (_cache[23] = ($event: any) => (_ctx.update())),
        ref: "autoWithdrawalSettingsModal"
      }, null, 512),
      _createVNode(_component_WithdrawalWhitelistModal, {
        ref: "withdrawalWhitelistModal",
        onUpdated: _cache[24] || (_cache[24] = ($event: any) => (_ctx.loadList()))
      }, null, 512),
      _createVNode(_component_ChangePasswordModal, { ref: "changePasswordModal" }, null, 512)
    ]),
    _: 1
  }, 512))
}